import { ReactNode } from "react";

import { CloseIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

type Props = {
  title?: string;
  titleIcon?: ReactNode;
  children?: ReactNode;
  className?: string;
  onClose: () => void;
};

const ModalHeader = ({
  title,
  titleIcon,
  children,
  className = "",
  onClose
}: Props) => {
  return (
    <div className={twMerge("flex flex-col px-4 mt-4", className)}>
      <div className="flex flex-row justify-between items-center">
        <div className="flex gap-2 items-center">
          {titleIcon}
          <h2 className="text-txtHeading font-sans font-bold text-[20px]">
            {title}
          </h2>
        </div>
        <div className="flex gap-3">
          {children}
          <button
            className="bg-transparent border-0 p-0"
            data-testid="modal-close-button"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon className="fill-dim-gray" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalHeader;
